import {CalendarDaysIcon} from "lucide-react";
import {HandRaisedIcon} from "@heroicons/react/16/solid";
import {Cards} from "@/pages/news/sections/ThirdSection/components/Cards";
import {Input, Radio} from "antd";

export const ThirdSection = () => {
    const content = [
        {
            title: "Quản lý đăng tuyển",
            description: "Với thư viện chuẩn của hơn 1000+ mô tả công việc gợi ý cho nhà tuyển dụng với các ngành nghề và vị trí khác nhau"
        },
        {
            title: "Quản lý ứng viên",
            description: "Với công cụ quản lý tích hợp, báo cáo trực quan, dễ sử dụng và theo dõi kho hồ sơ ứng viên theo từng vị trí đăng tuyển"
        },
        {
            title: "Quảng cáo đa nền tảng",
            description: "Với cơ chế kết hợp nguồn tiếp cận thông qua các kênh truyền thông mạng xã hội giúp tăng cơ hội tiếp cận ứng viên tiềm năng"
        }
    ]
    return (
        <div className="relative isolate overflow-hidden lg:block hidden bg-gray-900 rounded-lg shadow-md py-16 sm:py-24 lg:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto flex flex-col">
                    <h2 className="text-3xl font-bold text-center text-white">Phiên bản 2025 giúp đăng tuyển nhanh chóng
                        và hiệu quả hơn</h2>
                    <div className={"flex justify-center gap-4 mt-6"}>
                        {content.map((item, index) => (
                            <Cards key={index} {...item} />
                        ))}
                    </div>
                </div>
                <div className={"justify-center mx-auto"}>
                    <h2 className={"text-3xl font-bold text-center text-white mt-12"}>Hãy để chúng tôi hỗ trợ bạn</h2>
                    <p className={"text-center text-white mt-4"}>Chúng tôi luôn sẵn sàng hỗ trợ tư vấn và giải đáp mọi
                        thắc mắc của bạn về tuyển dụng nhân sự qua Vieclamsanxuat.com</p>
                </div>
                <div className="flex justify-center w-full mt-10">
                    <form className="flex flex-col gap-6 p-8 w-full max-w-lg bg-white/10 backdrop-blur-md rounded-xl shadow-xl">
                        <h3 className="text-2xl font-bold text-white text-center">Đăng ký nhận bản tin</h3>

                        <div className="grid gap-2">
                            <label className="text-white font-medium">Tên công ty</label>
                            <Input
                                placeholder="Nhập tên công ty"
                                className="w-full font-medium rounded-lg p-2"
                            />
                        </div>

                        <div className="grid gap-2">
                            <label className="text-white font-medium">Địa chỉ email</label>
                            <Input
                                type="email"
                                placeholder="Nhập email của bạn"
                                className="w-full font-medium rounded-lg p-2"
                            />
                        </div>

                        <div className="grid gap-2">
                            <label className="text-white font-medium">Số điện thoại</label>
                            <Input
                                type="tel"
                                placeholder="Nhập số điện thoại của bạn"
                                className="w-full font-medium rounded-lg p-2"
                            />
                        </div>

                        <div className="grid gap-2">
                            <label className="text-white font-medium">Quy mô công ty</label>
                            <Radio.Group className="flex flex-col gap-2 text-white">
                                <Radio className="text-white" value={1}>Dưới 50 nhân viên</Radio>
                                <Radio className="text-white" value={2}>Từ 50 - 100 nhân viên</Radio>
                                <Radio className="text-white" value={3}>Trên 100 nhân viên</Radio>
                            </Radio.Group>
                        </div>

                        <button
                            className="mt-4 bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-700 hover:to-cyan-700 text-white font-bold py-3 px-8 rounded-full transition duration-300"
                        >
                            Yêu cầu tư vấn
                        </button>
                    </form>
                    <img className={"w-96 h-96 my-14 ms-2"} src={"/img/tuyendung.png"} alt={"consultant"}/>
                </div>
            </div>
            <div aria-hidden="true" className="absolute w-full top-0 -z-10 xl:-top-6">
                <div
                    style={{backgroundImage: 'url("/img/newspage/banner.jpg")'}}
                    className="aspect-[1155/678] w-full opacity-30"
                />
            </div>
        </div>
    )
}